export default __webpack_public_path__ + "static/media/hills.90ee94f1.jpg";